import { Box, Stack, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { type ReactNode } from "react";

import { IconButton } from "../IconButton";

export interface BottomSheetHeaderProps {
  onBack?: React.MouseEventHandler<HTMLButtonElement>;
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
  children?: ReactNode;
  backButtonAriaLabel?: string;
  closeButtonAriaLabel?: string;
  closeButtonDisabled?: boolean;
  LinkComponent: React.ElementType;
}

const buttonSx: SxProps<Theme> = (theme) => ({
  width: theme.spacing(9),
  height: theme.spacing(9),
});

export function BottomSheetHeader(props: BottomSheetHeaderProps) {
  const {
    onBack,
    onClose,
    children,
    backButtonAriaLabel,
    closeButtonAriaLabel,
    closeButtonDisabled,
    LinkComponent,
  } = props;

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      sx={{
        paddingTop: (theme) => theme.spacing(6),
        paddingX: (theme) => theme.spacing(6),
        paddingBottom: (theme) => theme.spacing(2),
      }}
    >
      {onBack && (
        <IconButton
          iconType="chevron-left"
          size="medium"
          variant="outlined"
          aria-label={backButtonAriaLabel ?? "Go back"}
          LinkComponent={LinkComponent}
          sx={buttonSx}
          onClick={(event) => {
            event.stopPropagation();
            onBack(event);
          }}
        />
      )}

      <Box sx={{ flex: 1 }}>{children}</Box>

      {onClose && (
        <IconButton
          iconType="close"
          size="medium"
          variant="outlined"
          disabled={closeButtonDisabled}
          aria-label={closeButtonAriaLabel ?? "Close bottom sheet"}
          LinkComponent={LinkComponent}
          sx={buttonSx}
          onClick={(event) => {
            event.stopPropagation();
            onClose(event);
          }}
        />
      )}
    </Stack>
  );
}
